import { advantages, stats } from '@/mocks/baoyu';

export default function AdvantagesSection() {
  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <p className="text-sm text-primary-500 font-semibold tracking-wider mb-3">为什么选择 baoyu</p>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950">核心优势</h2>
          <p className="mt-4 text-foreground-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            baoyu 以技术创新为核心驱动，在安全、性能、续航和设计四大维度持续领先
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-20">
          {advantages.map((item) => (
            <div
              key={item.title}
              className="group p-6 md:p-8 rounded-2xl bg-background-100 border border-background-200/70 transition-all duration-300 hover:bg-background-100/80"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-500 mb-5 transition-colors duration-300 group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="text-lg font-semibold text-foreground-950 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-primary-500 mb-2">{stat.value}</div>
              <div className="text-sm text-foreground-600">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}